var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaterialSymbolsReceiptOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.5V1.5L3.375 2.625L4.5 1.5L5.625 2.625L6.75 1.5L7.875 2.625L9 1.5L10.125 2.625L11.25 1.5L12.375 2.625L13.5 1.5L14.625 2.625L15.75 1.5V16.5L14.625 15.375L13.5 16.5L12.375 15.375L11.25 16.5L10.125 15.375L9 16.5L7.875 15.375L6.75 16.5L5.625 15.375L4.5 16.5L3.375 15.375L2.25 16.5ZM4.5 12.75H13.5V11.25H4.5V12.75ZM4.5 9.75H13.5V8.25H4.5V9.75ZM4.5 6.75H13.5V5.25H4.5V6.75ZM3.75 14.325H14.25V3.675H3.75V14.325Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsReceiptOutline);
export default __webpack_public_path__ + "static/media/material-symbols_receipt-outline.c883d2c1027a3e43a73a1e2287e13dbd.svg";
export { ForwardRef as ReactComponent };